import { Component, OnInit, ViewChild  } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';

// SERVICES
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { DebounceService } from 'src/app/core/services/debounce.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { DialogService } from 'src/app/core/services/dialog.service';
import { PopUpDialogService } from 'src/app/services/popup-dialog.service';
import { ApiService } from 'src/app/services/api.service';
import { PaginationHelperService } from 'src/app/services/pagination-helper.service';
import { TableControlsComponent } from 'src/app/shared/component/table-controls/table-controls.component'; 
import { urlValidator } from 'src/app/shared/validators/url-validator';

// CONSTANTS
import {
  ANNOUNCEMENTS_TABLE_HEADERS,
  ANNOUNCEMENTS_TABLE_SUB_HEADERS
} from 'src/app/lib/constants/announcements.constants';

@Component({
  selector: 'app-features-announcement',
  templateUrl: './features-announcement.component.html',
  styleUrls: ['./features-announcement.component.scss']
})
export class FeaturesAnnouncementComponent implements OnInit {

  @ViewChild('tableControls') tableControls!: TableControlsComponent;

  // table
  tableHeader = ANNOUNCEMENTS_TABLE_HEADERS;
  tableSubHeader = ANNOUNCEMENTS_TABLE_SUB_HEADERS;

  img: any;
  announcement_lists: any;
  isLoading = true;

  // search
  searchKey: any = null;
  searchForm!: UntypedFormGroup;
  search_keyword = '';

  // limit
  limitKey: any = null;
  limitForm!: UntypedFormGroup;

  // pagination
  page = 1;
  size = 5;
  total_pages: any;
  current_page = 1;
  pages_array: number[] = [];
  total: any;
  lastPage: any;

  public announcementForm!: UntypedFormGroup;
  imageFile: { link: string, file: any, name: string } | null = { link: '', file: null, name: '' };

  // sorting
  sort_column = "createDate";
  sort_type: 'ASC' | 'DESC' = 'DESC';

  currentDate = new Date();
  status: any;

  // date validation
  minDate = new Date();
  minDateTo: Date | null = null;

  // print
  tabId: any;
  fileName: any;
  url: any;

  filterFields: any = {
    search: null,
  };

  constructor(
    private toastr: ToastrService,
    public request: RequestsService,
    private fb: UntypedFormBuilder,
    public debounce: DebounceService,
    private spinner: NgxSpinnerService,
    private dialogService: DialogService,
    private popUpDialogService: PopUpDialogService,
    private apiService: ApiService,
    public paginationHelper: PaginationHelperService
  ) {
    this.initializeForm();
  }

  ngOnInit(): void {
    this.get_announcement_list().catch((error: any) => {
      this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
    });

    const tableHeader = document.getElementsByTagName("th");
    for (let i = 0; i < tableHeader.length; i++) {
      tableHeader[i].classList.add("headerSortDown");
    }
  }

  initializeForm() {
    this.announcementForm = this.fb.group({
      webViewUrl: ['', [Validators.required, urlValidator.bind(this)]],
      dateFrom: ['', Validators.required],
      dateTo: [{ value: '', disabled: true }, Validators.required],
      description: ['', Validators.required],
      image: ['', Validators.required],
    });

    // Subscribe to dateFrom changes to enable/disable dateTo
    this.announcementForm.get('dateFrom')?.valueChanges.subscribe(dateFrom => {
      const dateToControl = this.announcementForm.get('dateTo');

      if (!dateToControl) {
        return;
      }

      if (dateFrom) {
        dateToControl.enable();
        this.minDateTo = new Date(dateFrom);

        const currentDateTo = dateToControl.value;
        if (currentDateTo && new Date(currentDateTo) < new Date(dateFrom)) {
          dateToControl.reset();
          this.toastr.warning('Date To has been cleared as it was earlier than Date From', 'Date Updated');
        }
      } else {
        dateToControl.disable();
        dateToControl.reset();
        this.minDateTo = null;
      }
    });

    this.searchKey = this.debounce.debounce(() => {
      this.current_page = 1;
      this.search_keyword = this.searchForm.value.search;
       this.filterFields.search = this.search_keyword ? this.search_keyword : null;
      console.log('searchKeyword', this.search_keyword);
      this.get_announcement_list().catch((error: any) => {
        this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
      });
    }, 500);

    this.limitKey = this.debounce.debounce(() => {
      this.current_page = 1;
      this.size = this.limitForm.value.limit;
      this.get_announcement_list().catch((error: any) => {
        this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
      });
    }, 500);

    this.searchForm = this.fb.group({
      search: ['']
    });

    this.limitForm = this.fb.group({
      limit: ['']
    });
  }

  onLimitChangeFromComponent(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.limitForm.patchValue({ limit: target.value });
    this.limitKey();
  }

  onSearchKeyupFromComponent(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.searchForm.patchValue({ search: target.value });
    this.searchKey();
  }

  sortList(sort_column: string, sort_type: 'ASC' | 'DESC') {
    this.spinner.show().catch((err) => {
      console.error('Spinner show sort error:', err);
    });

    const { column, type } = this.paginationHelper.toggleSort(
      this.sort_column,
      this.sort_type,
      sort_column,
      sort_type
    );

    this.sort_column = column;
    this.sort_type = type;

    if (this.announcement_lists) {
      this.get_announcement_list().catch((error: any) => {
        this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
      });
    }

    console.log('sort_column', this.sort_column);
    console.log('sort_type', this.sort_type);
  }

  onSelectFile(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];

      if (!file.type.startsWith('image/')) {
        this.toastr.error('Please select a valid image file', 'Invalid File Type');
        input.value = '';
        return;
      }

      const reader = new FileReader();
      const link = file;
      const name = file.name;
      reader.onload = (loadEvent: ProgressEvent<FileReader>) => {
        this.imageFile = {
          link: loadEvent.target?.result as string,
          file: link,
          name
        };
        this.img = loadEvent.target?.result;
      };
      reader.readAsDataURL(file);
      console.log(file.name);
    }
  }

  async get_announcement_list() {
    this.spinner.show().catch((err) => {
      console.error('Spinner show error:', err);
    });

    const params = {
      search: this.search_keyword ? this.search_keyword : null,
      sortBy: {
        [this.sort_column]: this.sort_type
      }
    };

    this.filterFields = { ...params };

    this.pages_array = [];

    const response = await firstValueFrom(
      this.apiService.getAnnouncements(params, this.current_page, this.size)
    );

    if (response.status === 200) {
      this.status = response.result.status;

      this.announcement_lists = response.result.data;
      this.isLoading = false;

      this.pages_array = this.paginationHelper.generatePageArray(
        this.current_page,
        response.result.totalPages
      );

      this.total_pages = response.result.totalPages;
      this.current_page = response.result.currentPage;
      this.total = response.result.totalItems;
      this.lastPage = response.result.totalPages;

      this.spinner.hide().catch((err) => {
        console.error('Spinner hide error:', err);
      });
    }
  }

  async store() {
    const webViewUrl = this.announcementForm.controls['webViewUrl'].value;
    const description = this.announcementForm.controls['description'].value;
    const dateFrom = this.announcementForm.controls['dateFrom'].value;
    const dateTo = this.announcementForm.controls['dateTo'].value;

    // Check required fields
    if (!webViewUrl || webViewUrl.trim() === '') {
      this.toastr.error('Please enter URL', 'Required Field Missing');
      return;
    }

    // Validate URL format
    const webViewUrlControl = this.announcementForm.get('webViewUrl');
    if (webViewUrlControl?.hasError('invalidUrl')) {
      this.toastr.error('Please enter a valid URL (must start with http:// or https://)', 'Invalid URL Format');
      return;
    }

    if (!description || description.trim() === '') {
      this.toastr.error('Please enter Description', 'Required Field Missing');
      return;
    }

    if (!dateFrom) {
      this.toastr.error('Please select Date From', 'Required Field Missing');
      return;
    }

    if (!dateTo) {
      this.toastr.error('Please select Date To', 'Required Field Missing');
      return;
    }

    // Validate dates are not in the past
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDateFrom = new Date(dateFrom);
    selectedDateFrom.setHours(0, 0, 0, 0);

    const selectedDateTo = new Date(dateTo);
    selectedDateTo.setHours(0, 0, 0, 0);

    if (selectedDateFrom < today) {
      this.toastr.error('Date From cannot be in the past', 'Invalid Date');
      return;
    }

    if (selectedDateTo < today) {
      this.toastr.error('Date To cannot be in the past', 'Invalid Date');
      return;
    }

    // Validate Date To is not before Date From
    if (selectedDateTo < selectedDateFrom) {
      this.toastr.error('Date To must be equal to or after Date From', 'Invalid Date Range');
      return;
    }

    if (!this.imageFile || !this.imageFile.file) {
      this.toastr.error('Please select an image', 'Required Field Missing');
      return;
    }

    // Confirm before saving
    this.popUpDialogService.openSaveActionDialog(
      'Are you sure you want to save this announcement?',
      async () => {
        await this.performStore(webViewUrl, description, dateFrom, dateTo);
      },
      () => {
        console.log('Save cancelled by user');
      }
    );
  }

  setPage(num: number) {
    this.current_page = num;
    this.get_announcement_list().catch((error: any) => {
      this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
    });
  }

  nextPage() {
    if (this.current_page < Number(this.total_pages)) {
      this.current_page++;
      this.get_announcement_list().catch((error: any) => {
        this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
      });
    }
  }

  prevPage() {
    if (this.current_page > 1) {
      this.current_page--;
      this.get_announcement_list().catch((error: any) => {
        this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
      });
    }
  }

  keyDownFunction(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.searchList();
    }
  }

  searchList() {
    this.current_page = 1;
    this.search_keyword = this.searchForm.value.search;
    this.filterFields.search = this.search_keyword ? this.search_keyword : null;
    console.log('searchKeyword', this.search_keyword);
    this.get_announcement_list().catch((error: any) => {
      this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
    });
  }

  disable(uid: number, value: number) {
    const announcement = this.announcement_lists.find((a: any) => a.uid === uid);
    const announcementUrl = announcement?.webViewUrl || 'this announcement';

    this.popUpDialogService.openStatusActionDialog(
      `Are you sure you want to disable "${announcementUrl}"?`,
      'DISABLE',
      'CANCEL',
      async () => {
        await this.changeStatus(uid, value);
      },
      () => {
        console.log('❌ Disable cancelled by user');
      }
    );
  }

  onDateToContainerClick() {
    const dateFromValue = this.announcementForm.get('dateFrom')?.value;

    if (!dateFromValue) {
      this.toastr.error('Please select Date From first', 'Date From Required');
    }
  }

  onDateToClick(event: Event) {
    const dateFromValue = this.announcementForm.get('dateFrom')?.value;

    if (!dateFromValue) {
      event.stopPropagation();
      this.toastr.error('Please select Date From first', 'Date From Required');
    }
  }

  enable(uid: number, value: number) {
    const announcement = this.announcement_lists.find((a: any) => a.uid === uid);
    const announcementUrl = announcement?.webViewUrl || 'this announcement';

    this.popUpDialogService.openStatusActionDialog(
      `Are you sure you want to enable "${announcementUrl}"?`,
      'ENABLE',
      'CANCEL',
      async () => {
        console.log('✅ ENABLE confirmed, calling changeStatus');
        await this.changeStatus(uid, value);
      },
      () => {
        console.log('❌ Enable cancelled by user');
      }
    );
  }

  async changeStatus(uid: number, value: number) {
    try {
      this.spinner.show().catch((err) => {
        console.error('Spinner show error:', err);
      });

      const response = await firstValueFrom(
        this.apiService.setStatusAnnouncement(uid, value)
      );

      if (response.status === 200) {
        const announcement = this.announcement_lists.find((a: any) => a.uid === uid);
        if (announcement) {
          announcement.status = value;
        }

        await this.get_announcement_list();

        const action = value === 0 ? 'enabled' : 'disabled';
        this.popUpDialogService.openSuccessDialog(
          `Announcement has been ${action} successfully!`
        );

        setTimeout(() => {
          this.spinner.hide().catch((err) => {
            console.error('Spinner hide error:', err);
          });
        }, 500);
      } else {
        this.popUpDialogService.openErrorDialog(
          'Failed to update status. Please try again.'
        );

        setTimeout(() => {
          this.spinner.hide().catch((err) => {
            console.error('Spinner hide error:', err);
          });
        }, 500);
      }

    } catch (error: any) {
      const errorMessage = error?.error?.message || error?.message || 'Something went wrong!';
      this.popUpDialogService.openErrorDialog(errorMessage);

      this.spinner.hide().catch((err) => {
        console.error('Spinner hide error:', err);
      });
    }
  }
  async refresh() {
    // reset the create-announcement form and image preview
    this.announcementForm.reset();
    this.img = null;
    this.imageFile = null;

    // reset search input/form
    this.tableControls?.searchForm.patchValue({ search: '' });
    this.search_keyword = '';
    this.searchForm.reset({ search: '' });

    // reset limit back to default
    this.limitForm.reset({ limit: '' });
    this.size = 5;

    // reset sort back to default
    this.sort_column = 'createDate';
    this.sort_type = 'DESC';

    // reset pagination back to page 1
    this.current_page = 1;

    // reset filterFields back to default shape
    this.filterFields = {
      search: null,
    };

    // refetch the default list with the reset params
    await this.get_announcement_list().catch((error: any) => {
      this.toastr.error(`Please refresh or contact the developer if the error still occurs: ${error}`, 'Failed Fetching Announcements');
    });
  }

  async print() {
    this.spinner.show().catch((err) => {
      console.error('Spinner show error:', err);
    });

    const current = new Date();
    this.fileName = current.toLocaleDateString() + "-announcements.xlsx";

    try {
      const report = await firstValueFrom(
        this.apiService.exportAnnouncements(this.filterFields)
      );

      const blob = new Blob([report], { type: 'application/vnd.ms-excel' });
      const data = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = data;
      link.download = this.fileName;
      link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

      setTimeout(() => {
        this.spinner.hide().catch((err) => {
          console.error('Spinner hide error:', err);
        });
      }, 500);
    } catch (error) {
      this.toastr.error('Failed to export', 'Error!');
      this.spinner.hide().catch((err) => {
        console.error('Spinner hide error:', err);
      });
    }
  }

  private async performStore(webViewUrl: string, description: string, dateFrom: any, dateTo: any) {
    this.spinner.show().catch((err) => {
      console.error('Spinner show error:', err);
    });

    const formData = new FormData();

    const processedUrl = webViewUrl;

    formData.append('webViewUrl', processedUrl);
    formData.append('dateFrom', moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss'));
    formData.append('dateTo', moment(dateTo).format('YYYY-MM-DDTHH:mm:ss'));
    formData.append('description', description);
    formData.append('image', this.imageFile!.file);

    console.log('Submitting announcement with data:', {
      webViewUrl: processedUrl,
      dateFrom: moment(dateFrom).format('YYYY-MM-DDTHH:mm:ss'),
      dateTo: moment(dateTo).format('YYYY-MM-DDTHH:mm:ss'),
      description,
      imageFile: this.imageFile!.name
    });

    try {
      const response = await this.apiService.storeAnnouncement(formData);

      if (response.status === 200 || response.status === 201) {
        this.popUpDialogService.openSuccessDialog(
          'Announcement has been saved successfully!'
        );

        this.page = this.lastPage;
        await this.get_announcement_list();
      } else {
        this.popUpDialogService.openErrorDialog(
          'Failed to create announcement. Please check all fields.'
        );
      }

      setTimeout(() => {
        this.spinner.hide().catch((err) => {
          console.error('Spinner hide error:', err);
        });
      }, 500);

      // RESET FORM AND IMAGE
      this.announcementForm.reset();
      this.img = null;
      this.imageFile = null;

    } catch (error: any) {
      const errorMessage = error?.error?.message || error?.message || 'Something went wrong!';
      this.popUpDialogService.openErrorDialog(errorMessage);

      this.spinner.hide().catch((err) => {
        console.error('Spinner hide error:', err);
      });
    }
  }

}
